import { Button } from "@/components/ui/button";
import { useAuth } from "react-oidc-context";
import { useQueryPresencePKSKPrefix } from "../hooks/data/use-presence-data";
import { useUserId } from "../hooks/useUserId";
import type { PresenceMonth } from "../types/presence";
import LoadingOverlay from "@/components/LoadingOverlay";

export function Profile() {
  const userId = useUserId();

  const { signoutRedirect } = useAuth();
  const { data: presenceSent, isLoading } =
    useQueryPresencePKSKPrefix<PresenceMonth>(`${userId}`, `presenceMonth#`);
  return (
    <>
      <Button variant="outline" onClick={() => signoutRedirect()}>
        Logout
      </Button>
      {isLoading && <LoadingOverlay />}
      {!isLoading && (
        <ul className="mt-4 divide-y border rounded-md">
          {presenceSent?.map((presence) => (
            <li
              key={`${presence.year}-${presence.month}`}
              className="px-4 py-2 text-sm"
            >
              {presence.year} - {presence.month} : {presence.days.length} giorni
              , inviato il {new Date(presence.sendDate!).toLocaleDateString()}
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
